import axios from '../request';

export default {
  getDashboardData: async (days = 30) => {
    const response = await axios.post('/Api/Dashboard/dashboardIndex', { days });
    return response.data;
  },
};
